import { Account, AccountOrProfile, CompanyAccount, Profile } from '../../MyLom/Account/EditAccount/Types';
import { CustomerId } from './Types';

export const isCompanyAccount = (account: Account): account is CompanyAccount => account.companyName !== null;

export const isProfile = (accountOrProfile: Account | Profile): accountOrProfile is Profile =>
    accountOrProfile.hasOwnProperty('profileName');

export const createAccountOrProfile = (accountOrProfile: Account | Profile): AccountOrProfile => ({
    id: accountOrProfile.id,
    displayName: isProfile(accountOrProfile)
        ? accountOrProfile.profileName
        : `${accountOrProfile.firstName} ${accountOrProfile.lastName}`,
    excludedIngredients: accountOrProfile.excludedIngredients,
    skinAnalyses: accountOrProfile.skinAnalyses,
});

export const isTestAccount = (customerId: CustomerId): boolean => customerId === 'd1921adb-f262-423f-b8b3-9548363ce98e';
